import { TAssetInvestmentDetailsSchema } from '@brickwise/asset-validation/dist/asset/investmentData';
import { useFormikContext } from 'formik';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { DefaultSelectField } from 'src/components/mui-overrides/SelectTextField';
import { TTerminationRightFrequency } from 'src/models/enum';

interface Props {
  disabled?: boolean;
}

export const TerminationRightFrequencySelector: FC<Props> = ({ disabled }) => {
  const formik = useFormikContext<TAssetInvestmentDetailsSchema>();
  const { t } = useTranslation();

  return (
    <DefaultSelectField
      disabled={disabled}
      label={t('dashboard.assets.addedit.investment.securitytype.fields.terminationrightfrequency')}
      fieldName="investmentDetails.terminationRightFrequency"
      formik={formik}
      options={[
        {
          value: TTerminationRightFrequency.five,
          label: t('general.terminationRightFrequency.five'),
        },
        {
          value: TTerminationRightFrequency.ten,
          label: t('general.terminationRightFrequency.ten'),
        },
        {
          value: TTerminationRightFrequency.fiveteen,
          label: t('general.terminationRightFrequency.fiveteen'),
        },
        {
          value: TTerminationRightFrequency.twenty,
          label: t('general.terminationRightFrequency.twenty'),
        },
      ]}
    />
  );
};
